module.exports = "<div style=\"text-align:center\">\n    <app-exercise-starter \n        [inPoints]=\"mPoints\"\n        [inState]=\"mState\"\n        (onSetLevel)='setLevel($event)'\n        (onSetState)='setState($event)'>\n    </app-exercise-starter>\n    <div [ngSwitch]=\"mCalcState\">\n        <app-multiply-calc *ngSwitchCase=\"'true'\" \n            [level]=\"mLevel\" (onPoints)=\"setPoints($event)\">\n        </app-multiply-calc>\n    </div> \n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/multiply/multiply.component.html
// module id = ../../../../../src/app/multiply/multiply.component.html
// module chunks = main